import { createTheme } from "@mui/material/styles";

const fontFamily = '"Plus Jakarta Sans", sans-serif';

const baseTheme = createTheme({
  typography: {
    fontFamily,
    fontSize: 14,
    h1: { fontFamily },
    h2: { fontFamily },
    h3: { fontFamily },
    h4: { fontFamily },
    h5: { fontFamily },
    h6: { fontFamily },
    button: { fontFamily },
  },
});

const theme = createTheme({
  ...baseTheme,
  palette: {
    primary: {
      main: "#0D109F",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

export default theme;
